import React from 'react';
import { content } from '../data/content';
import { motion } from 'framer-motion';
import { Quote, ArrowLeft, ArrowRight } from 'lucide-react';

const Testimonial = () => {
  return (
    <section className="py-24 bg-white border-b border-navy/5">
      <div className="container-custom">
        <div className="flex flex-col md:flex-row justify-between items-end mb-16 gap-8">
          <div className="max-w-xl">
            <h2 className="text-4xl lg:text-5xl mb-6 font-display">
              {content.testimonial.sectionTitle}
            </h2>
            <p className="text-navy/60 text-lg">
              At Keel Info Solutions, support is more than just service—it's about success.
            </p>
          </div>
          <div className="flex gap-4">
            <button className="w-12 h-12 flex items-center justify-center rounded-full border border-navy/10 hover:bg-navy hover:text-white transition-all">
              <ArrowLeft />
            </button>
            <button className="w-12 h-12 flex items-center justify-center rounded-full border border-navy/10 hover:bg-navy hover:text-white transition-all">
              <ArrowRight />
            </button>
          </div>
        </div>

        <div className="grid lg:grid-cols-12 gap-12 items-center">
          <motion.div 
            initial={{ opacity: 0, x: -20 }}
            whileInView={{ opacity: 1, x: 0 }}
            className="lg:col-span-4 rounded-3xl overflow-hidden aspect-square border-8 border-navy/5"
          >
            <img 
              src="/testimonial-author.jpg" 
              alt={content.testimonial.author} 
              className="w-full h-full object-cover"
            />
          </motion.div>

          <motion.div 
            initial={{ opacity: 0, x: 20 }}
            whileInView={{ opacity: 1, x: 0 }}
            className="lg:col-span-8 lg:pl-12"
          >
            <Quote size={60} className="text-primary/20 mb-8" />
            <p className="text-2xl lg:text-3xl font-medium text-navy leading-relaxed mb-10 italic">
              "{content.testimonial.quote}"
            </p>
            <div>
              <h4 className="text-xl font-bold text-navy">{content.testimonial.author}</h4>
              <p className="text-navy/60">{content.testimonial.role}</p>
            </div>
            
            <div className="mt-12 pt-8 border-t border-navy/5 flex items-center gap-8">
              <span className="text-sm font-bold text-navy/40 uppercase tracking-widest">Featured In</span>
              <div className="flex gap-8 opacity-20 grayscale">
                <span className="font-bold text-xl">Forbes</span>
                <span className="font-bold text-xl">TechCrunch</span>
                <span className="font-bold text-xl">Wired</span>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default Testimonial;
